import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let ApplicationMapSearchService = class ApplicationMapSearchService {
    isMapVisible = new BehaviorSubject(false);
    isMapVisibleAsObservable = this.isMapVisible.asObservable();
    isMapLoaded = new BehaviorSubject(false);
    isMapLoadedAsObservable = this.isMapLoaded.asObservable();
    isMapLarge = new BehaviorSubject(false);
    isMapLargeObservable = this.isMapLarge.asObservable();
    graphicsWithBuffer = new BehaviorSubject(null);
    graphicsWithBufferObservable = this.graphicsWithBuffer.asObservable();
    isBufferEnabled;
    hasApplicationLayer;
    constructor() { }
    setIsMapVisible(visible) {
        this.isMapVisible.next(visible);
    }
    setMapSizeLarge(large) {
        this.isMapLarge.next(large);
    }
    setGraphicsWithBuffer(graphicsWithBuffer) {
        this.graphicsWithBuffer.next(graphicsWithBuffer);
    }
    setBufferEnabled(bufferEnabled) {
        this.isBufferEnabled = bufferEnabled;
    }
    static ctorParameters = () => [];
};
ApplicationMapSearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationMapSearchService);
export { ApplicationMapSearchService };
